import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		// private toastrService: ToastrService,
		private router: Router
	) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError((err) => {
				let error: any;
				if(!(typeof(err.name) != 'undefined' && err.name == 'TimeoutError')) {
					switch (err.status) {
						case 999:
							return throwError({
								error: err.error
							});
						case 401:
						default:
							if(err.error != undefined && err.error.ErrorCode != undefined && parseInt(err.error.errorCode) != 500) {
								return throwError(err.error);
							}
							else {
								error = typeof(err.error.Errors) == 'undefined' ? err.error.errors : err.error.Errors;
							}							
							break;
					}
					return throwError(error);
				}

				return throwError(err);
			})
		);
	}
}
